import { UUID } from "../generic/uuid";
import { createVatTaxDtoFromOfferVatTaxModel, VatTaxModel } from "./vatTax";
import { ImageModel } from "./image";
import { OrganisationDto } from "@vini-wine/core-dtos";
import { UserOrganisationModel } from "./userOrganisation";

export interface OrganisationModel extends UUID {
  // transform
  name: string;
  legalName: string;
  vatTax: VatTaxModel;
  defaultTimezone: string;

  // available includes
  avatar?: ImageModel;
  defaultSalesContactUserOrganisation?: UserOrganisationModel;
}

export const createOrganisationDtoFromOfferOrganisationModel = (
  organisation: OrganisationModel,
): OrganisationDto => {
  return {
    name: organisation.name,
    legalName: organisation.legalName,
    vatTax: createVatTaxDtoFromOfferVatTaxModel(organisation.vatTax),
    defaultTimezone: organisation.defaultTimezone,
    uuid: organisation.uuid,
  };
};

export const organisationNameIdentifier = (organisation: OrganisationModel) =>
  `${organisation.name} (${organisation.legalName})`;
